import React from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableCell,
  view,
  css,
} from '@sail/ui';

export const Basic = () => (
  <view.div
    uses={[
      css({
        background: 'surface',
        padding: 'medium',
        borderRadius: 'medium',
      }),
    ]}
  >
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderCell>Charge type</TableHeaderCell>
          <TableHeaderCell>Amount</TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>Setup fee</TableCell>
          <TableCell>$95.00</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Maintenance fee</TableCell>
          <TableCell>$50.45</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Extra storage space (per GB)</TableCell>
          <TableCell>$5.95</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Premium features</TableCell>
          <TableCell>$109.00</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </view.div>
);
